import { EInvitationDeliveryStatus, type InvitationHistoryEntryDto } from '@src/types/InvitationHistoryDto'
import { ECommunicationType } from '@src/types/InvitationSchema'

const DELIVERY_RESOLUTION_WINDOW_MS = 60 * 60 * 1000

const TERMINAL_DELIVERY_STATUSES: EInvitationDeliveryStatus[] = [
  EInvitationDeliveryStatus.Delivered,
  EInvitationDeliveryStatus.Failed,
]

export const hasResolvableChannel = (entries: InvitationHistoryEntryDto[] | undefined, now: number): boolean =>
  (entries ?? []).some((entry) =>
    entry.channels.some((channel) => {
      if (channel.deliveryStatus === null || TERMINAL_DELIVERY_STATUSES.includes(channel.deliveryStatus)) {
        return false
      }

      return now - new Date(channel.sentAt ?? entry.sentAt).getTime() < DELIVERY_RESOLUTION_WINDOW_MS
    }),
  )

export interface InvitationHistoryRow {
  id: string
  invitationId: string
  communicationType: ECommunicationType
  recipient: string | null
  deliveryStatus: EInvitationDeliveryStatus | null
  firstName: string | null
  lastName: string | null
  languageId: number
  amount: number | null
  sentAt: string
  sentByUserFullname: string | null
  isResend: boolean
  entry: InvitationHistoryEntryDto
  isGrouped: boolean
  isFirstOfGroup: boolean
}

export const toChannelRows = (
  entries: InvitationHistoryEntryDto[],
  channelFilter?: ECommunicationType | null,
): InvitationHistoryRow[] =>
  entries.flatMap((entry) => {
    const channels =
      channelFilter && channelFilter !== ECommunicationType.Both
        ? entry.channels.filter((channel) => channel.communicationType === channelFilter)
        : entry.channels

    return channels.map((channel, index) => ({
      id: `${entry.id}:${channel.communicationType}`,
      invitationId: entry.id,
      communicationType: channel.communicationType,
      recipient: channel.recipient,
      deliveryStatus: channel.deliveryStatus,
      firstName: entry.firstName,
      lastName: entry.lastName,
      languageId: entry.languageId,
      amount: entry.amount ?? null,
      sentAt: channel.sentAt ?? entry.sentAt,
      sentByUserFullname: entry.sentByUserFullname,
      isResend: Boolean(entry.resentFromInvitationId),
      entry,
      isGrouped: entry.channels.length > 1,
      isFirstOfGroup: index === 0,
    }))
  })
